export const decodeHtmlEntities = value => {
    if (value == null || value === '') return '';
    const text = String(value);
    if (typeof document !== 'undefined') {
        const el = document.createElement('textarea');
        el.innerHTML = text;
        return el.value;
    }
    return text
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
};

export const formatPlainText = value => decodeHtmlEntities(value).replace(/\s+/g, ' ').trim();

export const stripHtmlToPlainText = value => {
    if (value == null || value === '') return '';
    const decoded = decodeHtmlEntities(String(value));
    if (typeof document !== 'undefined') {
        const el = document.createElement('div');
        el.innerHTML = decoded;
        return (el.textContent || el.innerText || '').replace(/\s+/g, ' ').trim();
    }
    return decoded.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
};

export const formatPdfDate = value => {
    if (!value) return '';
    try {
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '';
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
    } catch {
        return '';
    }
};

export const formatPdfDateTime = value => {
    if (!value) return '';
    try {
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '';
        const datePart = date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
        const timePart = date.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        });
        return `${datePart} ${timePart}`;
    } catch {
        return '';
    }
};

export const getVisibleColumnsFromOrder = (columnOrder, labelMap, isColumnVisible) =>
    (columnOrder || [])
        .filter(key => isColumnVisible(key) && labelMap[key])
        .map(key => ({ key, label: labelMap[key] }));

export const getVisibleColumnsFromState = columnState =>
    Object.keys(columnState || {})
        .filter(key => columnState[key]?.value)
        .map(key => ({ key, label: columnState[key].label || key }));

export const filterRowsByIds = (rows, selectedIds) => {
    if (!selectedIds?.length) return rows || [];
    const idSet = new Set(selectedIds.map(id => String(id)));
    return (rows || []).filter(row => idSet.has(String(row.id)));
};
